export default "__VITE_ASSET__DYsx0EZu__"